import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private appTitleSuffix =
    'Medical Assistance Transportation Program | Commonwealth of Pennsylvania';

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);

    if (routeTitle) {
      this.titleService.setTitle(`${routeTitle} | ${this.appTitleSuffix}`);
    } else {
      this.titleService.setTitle(this.appTitleSuffix);
    }
  }
}
